import React from "react";
import Hero from "../../components/Hero";
import VisionStatement from "./components/VisionStatement";
import CustomButton from "../../components/CustomButton";
import OurMission from "./components/OurMission";

import Industries from "./components/Industries";
import OurExpertise from "./components/OurExpertise";
import PartnerWithUs from "./components/PartnerWithUs";
import OurWorkCultures from "./components/OurWorkCultures";
import Footer from "../../components/Footer";
import { useNavigate, useOutletContext } from "react-router-dom";

export type LayoutContextType = { navbarHeight: number };
const Home = () => {
  const navigate = useNavigate();
  const { navbarHeight } = useOutletContext<LayoutContextType>();
  const handleNavigation = () => {
    navigate("/services");
  };
  return (
    <div className="w-full h-full bg-backgroundColor">
      <Hero
        title="Empowering Energy and Data Center Solutions for a Sustainable Future"
        description={`ECOCYNTEC Limited, established in 2023, provides expert engineering consulting for data centers and the energy industry. Our services include advanced liquid cooling, thermal management, performance optimization, and professional energy solutions across upstream, midstream, and downstream operations. We are committed to delivering high-quality, reliable results.`}
        src={require("../../assets/hero5.png")}
        navbarHeight={navbarHeight}
        button={
          <CustomButton
            title="Discover More"
            onClick={handleNavigation}
            className="w-28 h-10 md:w-[154px] md:h-[51px] text-base text-white cursor-pointer border-2  border-white"
          />
        }
      />
      <VisionStatement />
      <OurMission />
      <Industries />
      <OurExpertise />
      {/* <OurProjects /> */}
      <OurWorkCultures />
      <PartnerWithUs />
      <Footer />
    </div>
  );
};

export default Home;
